import React, { useEffect, useState } from "react"
import { InputComponent } from "../../../ui/molecules/input/index.tsx"
import { ButtonComponent } from "../../../ui/molecules/button/index.tsx"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts"
import {
    createNewSpontaneous, setCreateNewSpontaneousStatus, setSignUpStep,
    setSpontaneousFinancialAdvisorsCommercialName, setSpontaneousFinancialAdvisorsName,
    setSpontaneousFinancialAdvisorsPhoneNumber,
    setSpontaneousFinancialAdvisorsSurname, setSpontaneousFinancialAdvisorsVat
} from "./slice.ts"
import { SpinnerComponent } from "../../../ui/molecules/spinner/index.tsx"
import { ErrorPopup } from "../../../ui/organisms/errorPopup/index.tsx"

export function FinancialAdvisorRegisterForm() {

    const dispatch = useAppDispatch()
    const spontaneousState = useAppSelector(state => state.spontaneous)
    const { name, surname, commercialName, phoneNumber, vat } = spontaneousState.spontaneousFinancialAdvisorRequest
    const formData = new FormData()
    const [accepted, setAccepted] = useState(false)

    useEffect(() => {
        if (spontaneousState.createNewSpontaneousRequestStatus === 'successfully') {
            dispatch(setSignUpStep(2))
        }
    }, [spontaneousState.createNewSpontaneousRequestStatus])

    return (
        <>
            <ErrorPopup
                active={spontaneousState.createNewSpontaneousRequestStatus === 'failed'}
                close={() => {
                    dispatch(setCreateNewSpontaneousStatus('idle'))
                }}
                message="Errore durante la registrazione"
            />
            <h1 className=" font-bold text-heading-sm text-neutral-850">Parlaci di te</h1>
            <div className=' bg-white flex flex-col gap-[22px] items-center
                rounded-xl p-7 pt-0 sm:w-[80%] w-[120%] '>
                <div className=" flex flex-row gap-x-4 w-full">
                    <InputComponent onChangeText={(t) => dispatch(setSpontaneousFinancialAdvisorsName(t))}
                        required={spontaneousState.spontaneousFinancialAdvisorRequest.commercialName.trim().length === 0} label="Nome" placeholder="Nome" type={"text"} />
                    <InputComponent onChangeText={(t) => dispatch(setSpontaneousFinancialAdvisorsSurname(t))}
                        required={spontaneousState.spontaneousFinancialAdvisorRequest.commercialName.trim().length === 0} label="Cognome" placeholder="Cognome" type={"text"} />
                </div>
                <InputComponent onChangeText={(t) => dispatch(setSpontaneousFinancialAdvisorsCommercialName(t))}
                    required={spontaneousState.spontaneousFinancialAdvisorRequest.name.trim().length === 0 && spontaneousState.spontaneousFinancialAdvisorRequest.surname.trim().length === 0} label="Ragione sociale" placeholder="Ragione sociale" type={"text"} />
                <InputComponent onChangeText={(t) => { dispatch(setSpontaneousFinancialAdvisorsVat(t)) }}
                    required label="P.IVA" startIcon={<div className=" flex flex-row items-center">
                        <span className=" text-text-sm font-medium text-neutral-400">IT</span>
                    </div>} placeholder="P.IVA" type={"text"} />
                <div className=" flex flex-col gap-2.5 w-full">
                    <InputComponent startIcon={
                        <div className=" flex flex-row items-center">
                            <span className=" text-text-sm font-medium text-neutral-400">+39</span>
                        </div>
                    }
                        onChangeText={(t) => { dispatch(setSpontaneousFinancialAdvisorsPhoneNumber(t)) }}
                        required label="Telefono" placeholder="Telefono" type={"text"} />
                    <div className=" flex gap-2">
                        <input checked={accepted} onChange={() => setAccepted(!accepted)} id="checkbox" onClick={(e) => setAccepted} type="checkbox" placeholder="Accettazione Termini e Condizioni" />
                        <label htmlFor="checkbox" className=" text-text-xs font-semibold text-neutral-700">Dichiaro di aver letto e accettato i <a target="blank" href="https://fiscalbright.it/termini-condizioni/" className=" text-brandPrimary-500 underline">Termini e Condizioni</a> e il
                            <a target="blank" href="https://fiscalbright.it/dpa/" className=" text-brandPrimary-500 underline"> Data Processing Agreement</a>, e confermo la nomina di <strong>Madfarm S.r.l.</strong> come Responsabile del trattamento ai sensi del GDPR. </label>
                    </div>
                </div>
                {spontaneousState.createNewSpontaneousRequestStatus === 'idle' && <ButtonComponent onClick={() => {
                    formData.append('user',
                        JSON.stringify(spontaneousState.spontaneousFinancialAdvisorRequest)
                    )
                    dispatch(createNewSpontaneous(formData))
                }}
                    disabled={(!commercialName.trim() && !(name.trim() && surname.trim())) || !phoneNumber.length
                        || (vat.length < 11 || vat.length > 15 || !/^\d+$/.test(vat) || !/^\d{9,10}$/.test(phoneNumber) || !accepted)}
                    label="Avanti" fullWidth size={"md"} iconPosition={"off"} variant={"solid"} color={"blue"} />
                }
                {spontaneousState.createNewSpontaneousRequestStatus === 'loading' && <SpinnerComponent size={30} />}
            </div>
        </>
    )
}

